import { render, staticRenderFns } from "./edit-dialog.vue?vue&type=template&id=4ae8b28e&scoped=true&"
import script from "./edit-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-dialog.vue?vue&type=style&index=0&id=4ae8b28e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae8b28e",
  null
  
)

export default component.exports